import { ThunkActionCreator } from '.';

export const UPDATE_COLLAPSED = 'MASONRY.UPDATE_COLLAPSED';
export const UPDATE_CALENDAR_COLLAPSED = 'MASONRY.UPDATE_CALENDAR_COLLAPSED';

export const updateCollapsed: ThunkActionCreator = (collapsed: boolean) => async (dispatch) => {
  dispatch({
    type: UPDATE_COLLAPSED,
    payload: {
      collapsed,
    },
  });
};

export const updateCalendarCollapsed: ThunkActionCreator = (calendarCollapsed: boolean) => async (dispatch) => {
  dispatch({
    type: UPDATE_CALENDAR_COLLAPSED,
    payload: {
      calendarCollapsed,
    },
  });
};
